import { Memory } from "@mui/icons-material";
import { Card, CardContent, Chip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { TrainingView } from "@my-helpers/common";

interface TrainingDetailProps {
    training?: TrainingView;
}

const TrainingDetail: React.FC<TrainingDetailProps> = ({ training }) => {
    return (
        <Card sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
        }}>
            <CardContent sx={{ flex: 1, overflow: 'auto', p: 2 }}>
                <Typography variant="h6" sx={{ mb: 2, display: 'flex', alignItems: 'center', fontSize: '1.1rem' }}>
                    <Memory sx={{ mr: 1, color: 'primary.main', fontSize: '1.2rem' }} />
                    Model Details
                </Typography>
                <Box sx={{ display: 'grid', gap: 2 }}>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
                            Format
                        </Typography>
                        <Typography variant="body2">
                            {training?.format || ''}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
                            Family
                        </Typography>
                        <Typography variant="body2">
                            {training?.family || ''}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
                            Parameter Size
                        </Typography>
                        <Typography variant="body2">
                            {training?.parameter_size || ''}
                        </Typography>
                    </Box>
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary' }}>
                            Quantization
                        </Typography>
                        <Typography variant="body2">
                            {training?.quantization_level || ''}
                        </Typography>
                    </Box>
                    {training?.families && (
                        <Box>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', color: 'text.secondary', mb: 1 }}>
                                Model Families
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                {training.families.map((family, index) => (
                                    <Chip
                                        key={index}
                                        label={family}
                                        size="small"
                                        variant="outlined"
                                    />
                                ))}
                            </Box>
                        </Box>
                    )}
                </Box>
            </CardContent>
        </Card>
    );
};

export default TrainingDetail;